module.exports = __webpack_public_path__ + "media/images/facebook-b6354194747c1dadc9dc4231857b7c1b.png";